@if ((messageService.getMessage() | async); as message) {
  <div
    class="message-handler-wrapper">
    <div class="message-header"
    [ngClass]="{
      'message-header-error': message.isError,
      'message-header-success': !message.isError && !message.warning,
      'message-header-warn': message.warning,
    }"></div>
    <div class="message-body message">
    <mat-card [ngClass]="{
        'error': message.isError ,
        'success': !message.isError && !message.warning,
        'warn': message.warning,
      }">
        <div class="card-content-container">
          @if (!message.isError) {
            <mat-icon>check_circle_outline</mat-icon>
          }
          @if (message.isError) {
            <mat-icon>highlight_off</mat-icon>
          }
          <span>{{message.title}}</span>
          <p [style.white-space]="'pre-wrap'">{{message.content}}</p>
          <button mat-icon-button
            [disableRipple]="true"
            (click)="dismiss()">
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        </div>
      </mat-card>
    </div>
  </div>
}
